(ns common.db.coeffects.env
  (:require [re-frame.core :as rf]))

(rf/reg-cofx :env
  (fn [cofx _]
    (assoc cofx :env js/window.__LEMONPI_ENV__)))
